import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { useApp } from '@/contexts';
import { useGetWorkers } from '@/pages/FieldAllocation/hooks/useGetWorkers';

type Props = {
  children: ReactNode;
};

const WorkerGuard = ({ children }: Props) => {
  const { selectedRegion } = useApp();

  const { error: errorFromPlatform, isLoading } = useGetWorkers({
    source: 'PLATFORM',
    planning_region_id: selectedRegion
  });

  if (isLoading) {
    return null;
  }

  if (errorFromPlatform) {
    return <Navigate to='..' replace />;
  }

  return <>{children}</>;
};

export default WorkerGuard;
